import type { HTMLAttributes, ReactElement } from 'react';
import { PixelIcon, type PixelIconName } from '../PixelIcon.js';

export type AlertTone = 'error' | 'warning' | 'info' | 'success';
export type AlertRole = 'alert' | 'status';

/** The tone's pixel icon (design system 02 §2.4): colour is never the only cue. */
const ALERT_ICONS: Record<AlertTone, PixelIconName> = {
  error: 'prohibited',
  warning: 'signal',
  info: 'effect',
  success: 'check',
};

export interface AlertProps extends HTMLAttributes<HTMLElement> {
  as?: 'div' | 'p' | 'section';
  tone?: AlertTone;
  role?: AlertRole;
}

export function Alert({
  as: Element = 'div',
  tone = 'error',
  role = 'alert',
  className,
  children,
  ...props
}: AlertProps): ReactElement {
  return (
    <Element
      {...props}
      className={[
        'cards-kit-alert',
        `cards-kit-alert--${tone}`,
        className,
      ].filter(Boolean).join(' ')}
      role={role}
    >
      <PixelIcon name={ALERT_ICONS[tone]} className="cards-kit-alert-icon" />
      {children}
    </Element>
  );
}
